import React from "react";
import { useAccordion } from "features/menu/components/AccordionN";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import AppIcon from "components/ui/AppIcon";
import AppDropDown from "components/ui/AppDropdown";

const SingleCategory = ({
  toggle,
  cat,
  editCat,
  keyVal,
  unLinkMenuCat,
  getCategoryInfo,
  onAddItem,
}) => {
  const { t } = useTranslation();
  const { selected, toggleItem } = useAccordion();
  const dropdownItems = [
    {
      label: (
        <span className="z-10 w-full flex py-1 px-3 text-14px text-black hover:text-indigo-600 border-b border-gray-200">
          {t("Add Item")}
        </span>
      ),
      key: "add-item",
    },
    {
      label: (
        <span className="z-10 w-full flex py-1 px-3 text-14px text-black hover:text-indigo-600 border-b border-gray-200">
          {t("Edit")}
        </span>
      ),
      key: "edit",
    },
    {
      label: (
        <span className="z-10 flex py-1 px-3 text-14px text-theme-red hover:text-indigo-600 font-semibold">
          {t("Delete")}
        </span>
      ),
      key: "delete",
    },
  ];

  const onDropdownItemClick = (key) => {
    if (key === "add-item") {
      if (selected !== toggle) {
        toggleItem(toggle);
      }
      onAddItem?.(cat?._id);
      return;
    }
    if (key === "edit") {
      editCat(keyVal);
      return;
    }
    if (key === "delete") {
      unLinkMenuCat(keyVal);
    }
  };

  return (
    <div
      className="flex cursor-pointer items-center justify-between mb-2 rounded-2xl border border-secondary-light bg-primary-light px-5 py-4 focus:outline-none"
      onClick={() => {
        toggleItem(toggle);
        if (selected !== toggle) getCategoryInfo(cat._id);
      }}
    >
      <div className="flex w-full items-center gap-4">
        <span className="z-10 flex cursor-pointer items-center justify-center">
          <span
            className={`transition-transform duration-200 ${
              selected === toggle ? "rotate-180" : ""
            }`}
          >
            <AppIcon name="arrowDown" size={18} />
          </span>
        </span>
        <h4 className="m-0 flex-1 text-16px font-semibold leading-none text-gray-900">
          {cat?.baseLanguage?.name}
        </h4>
      </div>
      <div
        className="flex text-end cursor-pointer items-center"
        onClick={(event) => event.stopPropagation()}
      >
        <AppDropDown
          icon="more"
          dropdownMenu={dropdownItems}
          onItemClick={onDropdownItemClick}
        />
      </div>
    </div>
  );
};
export default SingleCategory;

SingleCategory.propTypes = {
  toggle: PropTypes.string,
  cat: PropTypes.object,
  editCat: PropTypes.func,
  onAddItem: PropTypes.func,
  deleteCat: PropTypes.func,
  keyVal: PropTypes.number,
  itemCount: PropTypes.number,
};
